import React, { useState } from 'react';
import { Query, useMutation } from 'react-apollo';
import { Link, Route, Switch } from 'react-router-dom';
import Helmet from 'react-helmet/es/Helmet';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import MaterialTable from 'material-table';
import Spin from 'components/common/Spin';
import Button from '@material-ui/core/Button';
import { DELETE_CAMPAIGN, GET_CAMPAIGNS, ADD_CAMPAIGN } from 'graphql/campaigns';
import { toUserTimezone } from 'utils';
import CopyIcon from '@material-ui/icons/FileCopyOutlined';

import CreateCampaign from './create';
import { useSelector } from 'react-redux';
import useSnack from 'hooks/useSnack';
import Optout from './optout';

const Campaigns = ({ history }) => {
  const user = useSelector((s) => s.user.user);
  const [selected, setSelected] = useState();
  const [creteCampaign] = useMutation(ADD_CAMPAIGN);
  const [deleteCampaign] = useMutation(DELETE_CAMPAIGN);
  const snack = useSnack();

  const columns = [
    { title: 'Name', field: 'name' },
    { title: 'Type', field: 'delivery_type' },
    {
      title: 'Delivery At',
      field: 'delivery_at',
      render: (row) =>
        toUserTimezone(row.delivery_at, user.timezone).format('LLL'),
    },
    {
      title: 'Delivered At',
      field: 'ran_at',
      render: (row) =>
        row.ran_at
          ? toUserTimezone(row.ran_at, user.timezone).format('LLL')
          : 'Pending',
    },
  ];

  return (
    <Box>
      <Helmet title="Campaigns" />
      <Box textAlign="right" mb={1}>
        <Button
          component={Link}
          to={`/campaigns/optout`}
          variant="outlined"
          color="primary"
        >
          Optout List
        </Button>{' '}
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to={`/campaigns/create`}
          onClick={() => {
            setSelected(null);
          }}
        >
          Create Campaign
        </Button>
      </Box>
      <Query query={GET_CAMPAIGNS} fetchPolicy="cache-and-network">
        {({ data, loading, refetch }) => {
          const onDelete = async (row) => {
            await deleteCampaign({
              variables: {
                id: row.id,
              },
            });
            refetch();
            snack.success('Campaign deleted');
          };

          const onCopy = async (e, row) => {
            setSelected({
              name: row.name,
              recipients: row.recipients,
              message: row.message,
              delivery_type: row.delivery_type,
            });
            history.push(`/campaigns/create`);
          }

          return (
            <>
              <MaterialTable
                title={false}
                columns={columns}
                data={data?.campaigns}
                isLoading={loading}
                onRowClick={(e, row) => {
                  setSelected(row);
                  history.push(`/campaigns/${row.id}`);
                }}
                editable={{
                  onRowDelete: onDelete,
                }}
                actions={[
                  {
                    icon: () => <CopyIcon />,
                    tooltip: 'Copy',
                    onClick: onCopy
                  }
                ]}
              />
              <Switch>
                <Route path="/campaigns/optout" component={Optout} />
                <Route
                  path="/campaigns/create"
                  render={(props) => (
                    <CreateCampaign {...props} refetch={refetch} campaign={selected} />
                  )}
                />
                <Route
                  path="/campaigns/:id"
                  render={(props) => (
                    <CreateCampaign
                      {...props}
                      refetch={refetch}
                      campaign={selected}
                    />
                  )}
                />
              </Switch>
            </>
          );
        }}
      </Query>
    </Box>
  );
};

export default Campaigns;
